import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { LogoutRequest } from './logoutrequest';

export class LogoutAPI extends SixdeeCRBTAPI<LogoutRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/logout
        return "logout";
    }

    getRequestData()
    {
        return "identifier=" + this.getRequest().getLogoutRequest().getRefreshToken();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/myaccount/logout/logoutapi.tsx